import { AUTOMATION_ACTIONS } from "../enum";
import DeleteAutomationModal from "./DeleteAutomationModal/DeleteAutomationModal";

const AutomationsModal = ({
    showModal,
    closeModal,
    modalAction,
    selectedAutomation,
    handleSuccess,
}) => {
    switch (modalAction) {
        case AUTOMATION_ACTIONS.DELETE_AUTOMATION:
            return (
                <DeleteAutomationModal
                    showModal={showModal}
                    closeModal={closeModal}
                    selectedAutomation={selectedAutomation}
                    handleSuccess={handleSuccess}
                />
            );
        default:
            return null;
    }
};

export default AutomationsModal;
